import { IRequestIO, IResponseIO } from '../core/adapter';
import { AdapterIO, IAdapterIO } from '../core/adapter';
import { TOptions } from '../core/interceptor';
import { t_adapter } from '../core/io';

export type Cookies = Record<string, string>;
export type RequestCookie = IRequestIO & { data?: Cookies | string };
export type ResponseCookie = IResponseIO & { data: Cookies | null };

import f1 from'../../../pip/library/pi-f1/pi-f1.js';

const EXPIRES_PERSIST = 'expires=Fri, 31 Dec 9999 23:59:59 GMT';
const EXPIRES_DELETE = 'expires=Fri, 31 Dec 1999 23:59:59 GMT';

/**
 *
 */
export class CookieAdapterIO
  extends AdapterIO<RequestCookie, ResponseCookie, TOptions>
  implements IAdapterIO<RequestCookie, ResponseCookie, TOptions> {
  type = 'cookie' as t_adapter;

  protected async _query(path: string, request: RequestCookie) {
    if (request.signal?.aborted) {
      return { data: null };
    }

    const data = request.data;

    if (f1.is.exists(data)) {
      if (f1.is.string(data)) {
        this.__writeCookies(f1.write<string>(path, data, {}) as Cookies);
      } else {
        this.__writeCookies(data);
      }
    }

    const defaultValue = f1.is.string(data) ? '' : {};
    return {
      data: f1.read(path, defaultValue, this.__readCookies(document.cookie))
    } as ResponseCookie;
  }

  private __writeCookies(cookies: Cookies) {
    f1.each((v, k) => {
      document.cookie =
        null == v ? `${k}=?;${EXPIRES_DELETE};path=/` : `${k}=${encodeURIComponent(v)};${EXPIRES_PERSIST};path=/`;
    }, cookies);
  }

  private __readCookies(cookie: string): Cookies {
    return cookie.split('; ').reduce((cookies, kv) => {
      const [k, v] = kv.split('=');

      cookies[k] = decodeURIComponent(v);
      return cookies;
    }, {});
  }
}
